import { TenantCustomizationsContext } from "src/tenantCustomizations/TenantCustomizationsContext.tsx";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export const useTenantCustomizations = () => useContextOrThrow(TenantCustomizationsContext);